<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <h3>Grapes in <span>{{grapevineName}}</span> grapevine</h3>
      <HotTable :root="root" ref="grapesTable" :settings="hotSettings" :onAfterChange="afterChangeHandler"></HotTable>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from '../firebaseInit'

  export default {
    data: function () {
      return {
        root: 'grapes-table',
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        grapes: [],
        grapeIDs: [],
        grapesQuery: '',
        searchLimit: 200,
        pageLimit: 1500,
        grapevineName: '',
        hotSettings: {
          data: this.grapes,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Title', 'Content', 'Notes', 'Length', 'Publish Year', 'Translation', 'Type', 'User ID', 'Username', 'Source', 'Source Author', 'Source Date', 'Source ID', 'Source ISBN', 'Image', 'Amazon URL', 'ID', 'Created', 'Updated'],
          rowHeights: 50,
          colWidths: [180, 220, 250, 200, 80, 120, 100, 80, 100, 100, 200, 120, 100, 100, 100, 100, 200, 100, 150, 150],
          columns: [
            {data: 'docID', readOnly: true, type: 'numeric'},
            {data: 'grapeTitle', type: 'text'},
            {data: 'grapeContent', type: 'text'},
            {data: 'grapeNotes', type: 'text'},
            {data: 'grapeLength', type: 'numeric'},
            {data: 'grapeOriginalPublishYear', type: 'numeric'},
            {data: 'grapeTranslation', type: 'text'},
            {data: 'grapeType', type: 'text'},
            {data: 'grapeUserID', type: 'text'},
            {data: 'grapeUsername', type: 'text'},
            {data: 'grapeSource', type: 'text'},
            {data: 'sourceAuthor', type: 'text'},
            {data: 'sourceDate', type: 'text'},
            {data: 'sourceID', type: 'text'},
            {data: 'sourceISBN', type: 'text'},
            {data: 'sourceImage', type: 'text'},
            {data: 'amazonURL', type: 'text'},
            {data: 'id', readOnly: true, type: 'text'},
            {data: 'createdTimestamp', type: 'date'},
            {data: 'updatedTimestamp', type: 'date'}
          ]
        }
      }
    },
    name: 'grapesAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      vm.fetchData()
      /* Set Change Callback */
      vm.hotSettings.afterChange = vm.afterChangeHandler()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      afterChangeHandler: function (changes, source) {
        // if (arguments[1] !== 'loadData') {
        //   if (!changes) {
        //     return
        //   }
        //   for (var i = 0, iLen = changes.length; i < iLen; i += 1) {
        //     if (changes[i][2] !== changes[i][3]) {
        //       console.log('trying to change')
        //       let logicalIndex = this.$refs.grapesTable.table.runHooks('modifyRow', changes[i][0])
        //       let changedDocID = this.$refs.grapesTable.table.getDataAtCell(changes[i][0], 0)
        //       let newData = this.$refs.grapesTable.table.getSourceDataAtRow(logicalIndex)
        //       delete newData._highlightResult
        //       delete newData.objectID
        //       delete newData.docID
        //       console.log(changedDocID)
        //       console.log(newData)
        //       if (changedDocID) {
        //         this.processChange(changedDocID, newData)
        //       }
        //     }
        //   }
        // }
      },
      fetchData () {
        this.getGrapevineGrapes()
        if (this.$route.params.name !== '') {
          this.grapevineName = decodeURIComponent(this.$route.params.name)
        }
      },
      getGrapevineGrapes: function () {
        console.log('getGrapevineGrapes')
        let vm = this
        vm.grapeIDs = []
        vm.grapes = []
        var grapevineRef = db.collection('grapevines').doc(vm.$route.params.id)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            vm.grapevineName = doc.data().name
            let grapes = doc.data().grapes
            for (var i = 0; i < grapes.length; i++) {
              vm.grapeIDs.push(grapes[i])
            }
            vm.getGrapes()
          }
        })
      },
      getGrapes: function () {
        console.log('get grapes')
        let vm = this
        vm.grapeIDs.forEach(grapeID => {
          db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapeData.docID = doc.id
              vm.grapes.push(grapeData)
            })
            /* Load Data */
            vm.$refs.grapesTable.table.loadData(vm.grapes)
            setTimeout(function () {
              vm.hideLoading()
            }, 1000)
          })
        })
      },
      doGrapeSearch () {
        let vm = this
        vm.grapes = []
        var client = algoliasearch('BLP5M7YD97', 'e43146fabb439a15a2622c0264710cb6')
        var index = client.initIndex('grapes')
        var query = vm.grapesQuery
        index.search({
          query: query,
          hitsPerPage: vm.searchLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            vm.grapes.push(obj)
          }
          /* Load Data */
          vm.$refs.grapesTable.table.loadData(vm.grapes)
        })
      },
      clearSearch () {
        let vm = this
        vm.grapes = []
        vm.getGrapes()
      },
      processChange (docID, newData) {
        console.log('trying to update grape')
        let vm = this
        var grapeRef = db.collection('grapes').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        newData.updatedTimestamp = timestamp
        grapeRef.update(newData)
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
          newData.docID = docID
          delete newData._highlightResult
          vm.algoliaIndex(newData)
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      }
    }
  }
</script>

<style>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  #grapes-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 120px);
    margin-top: 4px;
    overflow: hidden;
  }
  #grapes-table th {
    vertical-align: middle;
  }
  #grapes-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grapes-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/grapevineAdmin.vue